import React from 'react';
import Layout from '../../components/Layout/Layout';
import ContactForm from '../../components/ContactForm/ContactForm';
import styles from './Contact.module.css';
const Contact = () => {
    return (React.createElement(Layout, { currentPath: "/contact" },
        React.createElement("section", { className: styles.contactHero },
            React.createElement("div", { className: styles.heroContent },
                React.createElement("h1", null, "Let's Discuss Your Challenges"),
                React.createElement("p", null, "Working on government innovation, procurement modernization, or startup engagement? I'd be happy to discuss your specific context."))),
        React.createElement("section", { className: styles.contactSection },
            React.createElement("div", { className: styles.content },
                React.createElement("div", { className: styles.intro },
                    React.createElement("h2", null, "What to Expect"),
                    React.createElement("ul", null,
                        React.createElement("li", null,
                            React.createElement("strong", null, "Initial consultation:"),
                            " Starts with a conversation to understand your challenges and determine if there's a fit"),
                        React.createElement("li", null,
                            React.createElement("strong", null, "No generic solutions:"),
                            " Every program has unique constraints\u2014procurement authorities, stakeholder dynamics, technical debt"),
                        React.createElement("li", null,
                            React.createElement("strong", null, "Practical focus:"),
                            " Recommendations that work within your actual authorities and timelines, not theoretical best practices"))),
                React.createElement("div", { className: styles.formContainer },
                    React.createElement(ContactForm, null))))));
};
export default Contact;
